export default "__VITE_ASSET__KuVUfVPG__"